import { LinkButton } from "../ui/Button";
import { PageHeader } from "../ui/Page";

export function NotFoundPage() {
  return (
    <div className="page page--narrow">
      <PageHeader title="Sayfa bulunamadı" lead="Aradığınız sayfa taşınmış ya da size açık olmayabilir." />
      <LinkButton to="/" variant="primary" icon="house">
        Bugün'e dön
      </LinkButton>
    </div>
  );
}
